import { render } from "./TaxIdentification.vue?vue&type=template&id=b7be9496&scoped=true"
import script from "./TaxIdentification.vue?vue&type=script&lang=js"
export * from "./TaxIdentification.vue?vue&type=script&lang=js"

import "./TaxIdentification.vue?vue&type=style&index=0&id=b7be9496&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7be9496"]])

export default __exports__